export class SignInUser {
  email: string;
  password: string;
  otp: string;
}
